









































import { Component, Prop, Vue } from "@/shared/vuepack";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import {
  planTypeMap,
  planSubTypeMap
} from "@/shared/types";
import { formatCurrency } from "@/shared/currency";
import { hsabAccountIcon } from "@/shared/awesomeIconMapper";
import moment from "moment";
import _ from "lodash";
import AccountHolderWidgetBase from "@/employer/components/partner-ee-service/v2/AccountHolderWidgetBase.vue";


@Component({
  components: {
    AccountHolderWidgetBase,
  }
})
export default class AccountHolderNotionalAccounts extends Vue {
  hsabAccountsStore = useHsabAccountsStore();
  formatCurrency = formatCurrency;
  hsabAccountIcon = hsabAccountIcon;
  planTypeMap = planTypeMap;
  planSubTypeMap = planSubTypeMap;
  loaded = false;

  @Prop({ required: true })
  username: string;

  @Prop({ required: true })
  partnerId: number;

  get isLoading () {
    return this.hsabAccountsStore.allHsabAccountsLoading;
  }

  get isLoaded () {
    return this.hsabAccountsStore.userHasNotionalAccountsLoaded;
  }

  get isFailed () {
    return this.hsabAccountsStore.hsabAccountsFailedToLoad;
  }

  get hasData () {
    return this.hsabAccountsStore.userHasActiveNotionalAccounts;
  }

  loadData () {
    if (!this.loaded) {
      const args = { username: this.username, partnerId: this.partnerId };
      this.hsabAccountsStore.adminReloadHsabAccounts(args);
      this.loaded = true;
    }
  }
  get notionalAccounts () {
    return _.orderBy(this.hsabAccountsStore.notionalAccounts.filter(x => x.isActive), "accountId", "desc");
  }
  getFormattedDate (date?: string): string {
    return date && moment(date).format("MMM D, YYYY") || "(unknown)";
  }
  listFields = [{
    key: "accountName",
    thClass: "text-left",
    tdClass: "",
    label: "Account Name"
  },
  {
    key: "accountBalance",
    thClass: "text-right",
    tdClass: "text-right",
    label: "Balance"
  },
  {
    key: "balanceDate",
    label: "Balance Date",
    thClass: "",
    tdClass: ""
  },
  {
    key: "startDate",
    thClass: "",
    tdClass: "",
    label: "Start Date"
  },
  {
    key: "endDate",
    label: "End Date",
    thClass: "",
    tdClass: ""
  },
  {
    key: "planType",
    label: "Plan Type",
    thClass: "text-left",
    tdClass: "text-left"
  },
  {
    key: "planSubType",
    label: "Plan Sub Type",
    thClass: "text-left",
    tdClass: "text-left"
  },
  {
    key: "finalServiceDate",
    label: "Final Service",
    thClass: "",
    tdClass: ""
  },
  {
    key: "finalFilingDate",
    label: "Final Filing",
    thClass: "",
    tdClass: ""
  }];
}
